export default "assets/85e64244d6b8b796e85bdd68ce38b1a2.png";